import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function editMilestone(
  milestone: Identifiable<Milestone>,
  nextMilestone: Milestone,
): Identifiable<Milestone> {
  return {
    ...milestone,
    ...nextMilestone,
  };
}

function handleEditConstraint(
  milestone: Identifiable<Milestone>,
  { impactedElements }: Boundaries["editConstraint"]["success"],
): Identifiable<Milestone> {
  const impactedMilestone = impactedElements.find(
    ({ uuid }) => uuid === milestone.uuid,
  );

  return !!impactedMilestone
    ? editMilestone(milestone, { ...milestone, ...impactedMilestone })
    : milestone;
}

export { handleEditConstraint };
